import React, { Component } from "react";
import { Line, Bar } from "react-chartjs-2";
import C from '../lib/Config';

export default class PatientWeightChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            followUpDates: [],
            patientWeight: []
        };
    }

    componentDidMount() {
        if (this.props.patientId) {
            this.getPatientWeightData(this.props.patientId);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.patientId && this.props.patientId !== prevProps.patientId) {
            this.getPatientWeightData(this.props.patientId);
        }
    }

    getPatientWeightData(patientId) {
        return fetch(C.getUrl() + '/userCase/patWeightChart?patientId=' + patientId)
            .then(res => res.json())
            .then(res => {
                if (res.statusCode === 200 && res.data && res.data.length) {
                    this.setState({
                        followUpDates: res.data.map(item => item.appointmentDt),
                        patientWeight: res.data.map(item => item.weight),
                    });
                }
            })
            .catch(err => {
            });
    }
    render() {
        const { followUpDates, patientWeight } = this.state;
        const data = {
            labels: followUpDates,
            datasets: [
                {
                    label: "Patient Weight to Followup Appointment",
                    fill: true,
                    //backgroundColor: "#beeddb",
                    backgroundColor: "rgba(75,192,192,0.2)",
                    borderColor: "rgba(75,192,192,1)",
                    data: patientWeight,
                },
            ],
        };

        const minWeight = patientWeight.length ? Math.min(...patientWeight) - 5 : 20;
        const maxWeight = patientWeight.length ? Math.max(...patientWeight) + 5 : 100;

        const options = {
            responsive: true,
            legend: {
                position: 'bottom'
            },
            tooltips: {
                callbacks: {
                    label: (tooltipItem) => `${tooltipItem.yLabel}`,
                },
            },
            scales: {
                yAxes: [
                    {
                        ticks: {
                            suggestedMin: minWeight,
                            suggestedMax: maxWeight
                        }
                    }
                ]
            }
        };
        return (
            <div>
                <Line data={data} options={options}/>
            </div>
        );
    }

}
